import {
    Box, Breadcrumbs, Button, Modal, FormControl, Paper, Typography, TextField
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { GET_PROMOTION_EXPIRY, SET_PROMOTION_EXPIRY} from '../constant/endpoint';

// Replace with your backend endpoints

const CreatePromotionExpiry = () => {
    const [open, setOpen] = useState(false);
    const [expiryDays, setExpiryDays] = useState("");
    const [currentDays, setCurrentDays] = useState(null);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Fetch current expiry days from backend/Redis
    const fetchExpiryDays = async () => {
        try {
            const { data } = await axios.get(GET_PROMOTION_EXPIRY);
            if(data?.data){
                setCurrentDays(data.data);
                setExpiryDays(data.data);
            }
            console.log(data.data,"----")
        } catch (err) {
            console.error("Failed to fetch expiry days", err);
        }
    };

    useEffect(() => {
        fetchExpiryDays();
    }, []);

    const handleSubmit = async () => {
        if (!expiryDays || isNaN(expiryDays) || expiryDays <= 0) {
            Swal.fire("Validation Error", "Please enter valid expiry days.", "warning");
            return;
        }

        try {
            await axios.post(SET_PROMOTION_EXPIRY, { days: parseInt(expiryDays) });
            Swal.fire("Success", "Promotion expiry days updated successfully!", "success");
            setCurrentDays(expiryDays);
            handleClose();
        } catch (error) {
            console.error("Error saving expiry days:", error);
            Swal.fire("Error", "Failed to update expiry days.", "error");
        }
    };

    return (
        <div className="homeCard">
            <div className="subHomeCard">
                <Breadcrumbs separator={<MdNavigateNext fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" key="1" color="inherit" to={""}>
                        <h4>Promotion Expiry</h4>
                    </Link>
                    <h5>Settings</h5>
                </Breadcrumbs>

                <Button
                    variant="contained"
                    color="primary"
                    style={{ float: "right" }}
                    onClick={handleOpen}
                >
                    Set Promotion Expiry
                </Button>

                <Paper sx={{ marginTop: 5, padding: 2 }}>
                    <Typography variant="h6">
                        Current Expiry Days: {currentDays ? `${currentDays} Days` : "Not Set"}
                    </Typography>
                </Paper>

                {/* Modal */}
                <Modal open={open} onClose={handleClose}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <FormControl fullWidth>
                            <TextField
                                label="Expiry Days"
                                type="number"
                                value={expiryDays}
                                onChange={(e) => setExpiryDays(e.target.value)}
                                inputProps={{ min: 1 }}
                            />
                        </FormControl>

                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Save
                        </Button>
                    </Box>
                </Modal>
            </div>
        </div>
    );
};

export default CreatePromotionExpiry;
